import React, { useState } from 'react';
import { Button } from '../components/template'; 

const LeadMagnetLanding = () => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [error, setError] = useState('');

  // WhatsApp number validation (10–15 digits, allows + at start)
  const phoneRegex = /^\+?[0-9]{10,15}$/;

const handlePhoneSubmit = async (e) => {
  e.preventDefault();

  if (!name.trim()) {
    setError('⚠️ Please enter your name.');
    return;
  }
  if (!phone) {
    setError('⚠️ Please enter your WhatsApp number.');
    return;
  }
  if (!phoneRegex.test(phone)) {
    setError('⚠️ Please enter a valid WhatsApp number.');
    return;
  }

  setIsSubmitting(true);
  setError('');

  const payload = {
    name,
    age: '',
    gender: '',
    city: '',
    phone, // sending WhatsApp number
    date_suits: '',
    price_suitable: '',
    reason: '',
    question: '', // keeping for backend compatibility
  };

  try {
    const BASE_URL =
      process.env.REACT_APP_ENV === 'PROD'
        ? process.env.REACT_APP_API_BASE_URL_PROD
        : process.env.REACT_APP_API_BASE_URL_DEV;

    // Run all requests in parallel
    const results = await Promise.allSettled([
      fetch(
        'https://zbpje4azgliercmqvfqkh34bqm0mlmwm.lambda-url.ap-south-1.on.aws/',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        }
      ),

      fetch(`${BASE_URL}/add-subscriber`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, phone }),
      }),

      fetch(
        'https://connect.pabbly.com/workflow/sendwebhookdata/IjU3NjYwNTY1MDYzNzA0MzQ1MjY5NTUzNTUxMzMi_pc',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name, phone }),
        }
      ),
    ]);

    // Check results
    const failed = results.filter(r => r.status === 'rejected');
    if (failed.length === 0) {
      // all succeeded
      setFormSubmitted(true);
    } else if (failed.length < results.length) {
      // some failed, some succeeded
      setFormSubmitted(true);
      setError('⚠️ Submitted successfully, but some services failed. We’ll double-check your entry.');
    } else {
      // all failed
      setError('⚠️ Unable to submit at the moment. Please try again later.');
    }
  } catch (error) {
    console.error('Unexpected error submitting form:', error);
    setError('⚠️ An error occurred. Please try again later.');
  } finally {
    setIsSubmitting(false);
  }
};


  return (
    <section className="flex flex-col md:flex-row items-center justify-between px-4 py-10 md:px-6 md:py-16 bg-white rounded-2xl shadow-2xl max-w-6xl mx-auto">

      {/* Left: Book Image - only show when form NOT submitted */}
      {!formSubmitted && (
        <div className="w-full md:w-1/2 mb-8 md:mb-0 flex justify-center">
          <img
            src="/bookcover1.png"
            alt="Deep Mental Reset Guide"
            className="w-48 md:w-[300px]"
          />
        </div>
      )}

      {/* Right: Content */}
      <div
        className={`w-full ${formSubmitted ? 'md:w-full' : 'md:w-1/2'} text-center md:text-left space-y-4`}
      >
        {!formSubmitted ? (
          <>
            <h2 className="text-2xl md:text-3xl font-bold text-secondary drop-shadow-sm">
              Feeling Mentally Fried? Foggy, Restless, Overwhelmed?
            </h2>

            <p className="text-lg md:text-xl font-semibold text-orange-500">
              You Don’t Need Another Break — You Need a Deep Mental Reset.
            </p>

            <p className="text-base text-gray-700 leading-relaxed">
              Discover the science-backed, soul-aligned 7-Day Protocol to clear your mind,
              calm your system, and restore inner focus — even on your busiest days.
            </p>
            <p className="text-[#578d48] mt-2 mb-4">
              <strong>No fluff.</strong> Just real, grounding tools that actually work.
            </p>

            {!isFormVisible ? (
              <Button
                variant="primary"
                size="md"
                text="Download FREE Guide — Deep Mental Reset"
                onClick={() => setIsFormVisible(true)}
                className="w-full md:w-auto shadow-lg hover:shadow-2xl transition-shadow duration-300"
              />
            ) : (
              <form onSubmit={handlePhoneSubmit} className="mb-3">
                {/* Name Field */}
                <input
                  type="text"
                  placeholder="Enter your Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="w-full md:w-80 border-2 border-primary rounded-md py-3 px-4 mb-4 focus:outline-none focus:ring-2 focus:ring-primary"
                  required
                />

                {/* WhatsApp Number Field */}
                <input
                  type="tel"
                  placeholder="Enter your WhatsApp Number"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  className="w-full md:w-80 border-2 border-primary rounded-md py-3 px-4 mb-4 focus:outline-none focus:ring-2 focus:ring-primary"
                  required
                />

                {error && <p className="text-red-600 text-sm">{error}</p>}

                <div className="flex flex-col sm:flex-row gap-4 justify-start mt-4">
                  <Button
                    type="submit"
                    variant="primary"
                    size="md"
                    text={isSubmitting ? 'Submitting...' : 'Subscribe To Download'}
                    className="w-full md:w-auto shadow-lg hover:shadow-2xl transition-shadow duration-300"
                    disabled={isSubmitting}
                  />
                </div>
              </form>
            )}

            <p className="text-sm text-red-600 font-medium pt-1">
              ⚠️ Available Free for a Limited Time — grab it now.
            </p>
          </>
        ) : (
          <div className="w-full h-full flex flex-col items-center justify-center text-center bg-gradient-to-r from-light to-accent py-16 px-6 rounded-xl shadow-inner">
            <h2 className="text-4xl md:text-5xl font-bold text-secondary mb-4">
              🎉 Congrats For Taking the First Step!
            </h2>
            <p className="text-xl font-semibold text-[#578d48] mb-2">
              Your free eBook – The Mental Reboot Framework is on its way to your WhatsApp.
            </p>

            <div className="pt-6">
              <Button
                variant="primary"
                text="Return to Home"
                size='md'
                onClick={() => (window.location.href = '/')}
              />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default LeadMagnetLanding;
